import { useAppBaseContext } from "providers/AppBaseProvider";
import { useProjectDataStore, useSetProject } from "stores/projectStore";
import type { FetchError } from "hooks/useFetch";
import { useFetch } from "hooks/useFetch";
import { ProjectTreeQry } from "api/queries";
import { toast } from "react-toastify";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface UseFetchProjectProps<T = any> {
  pause?: boolean;
  calculateOpenMap?: boolean;
  onError?: (error: FetchError) => void;
  onSuccess?: (data: T) => void;
}

export const useFetchProject = ({
  pause = true,
  onError,
  onSuccess,
}: UseFetchProjectProps = {}) => {
  const { lang, isSameProj } = useAppBaseContext() as {
    lang: string;
    isSameProj: boolean;
  };

  const projectId = useProjectDataStore((state) => state.projectId);
  const setError = useProjectDataStore((state) => state.setError);
  const setIsLoading = useProjectDataStore((state) => state.setIsLoading);
  const setProject = useSetProject();

  const refetch = useFetch({
    query: ProjectTreeQry,
    variables: {
      input: { id: projectId || "", languageCode: lang },
    },
    pause: !projectId || pause,
    onSuccess: ({ data, errors }) => {
      setProject({
        projectName: data.project.title,
        projectId: data.project.id,
        projectNodes: data.project.projectNodes,
        projectMandator: data.project?.mandator || null,
        units: data.project.unit.unit,
        isSameProj,
      });
      onSuccess?.({ data, errors });
    },
    onError: (error) => {
      setError(error);
      if (typeof onError === "function") {
        onError(error);
      } else {
        toast.error(error.message);
      }
    },
    setIsLoading,
  });

  return refetch;
};
